const documentEditMode = {
  NUMBER_DATE: 1,
  TOPIC: 2,
  EXECUTER: 3,
  CONTRACTOR: 4,
  ADDRESS: 5,
  DONE_DATE: 6,
  RESPONSIBLE_WORKER: 7,
  STATUS: 8,
  VISIBILITY: 9,
  REMINDER: 10,
  TOPIC_ID: 11,
  RESPONCE_TIME: 12,
};

export default documentEditMode;
